import { useEffect, useState } from "react";
import AppDrawer from "components/Drawers/AppDrawer";
import { Alert, Button } from "reactstrap";
import CustomToggle from "components/Drawers/Fields/CustomToggle";
import AppSpinner from "../../../elements/AppSpinner";

// Add additional settings here.
const initialSettings = {
  ShowAggregations: false,
};

const TableSettings = ({ open, onClose, existingSettings, saving, onSave }) => {
  const [settings, setSettings] = useState(initialSettings);
  const [message, setMessage] = useState(null);

  const handleCheckboxChange = (e) => {
    const { name } = e.target;

    setSettings((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  // Display a success message for a few seconds onSuccess.
  const handleSave = () => {
    onSave(settings, () => {
      setMessage({ color: "success", text: "Settings saved successfully!" });
      setTimeout(() => setMessage(null), 3000);
    });
  };

  // Initialize state with existingSettings.
  useEffect(() => {
    if (!existingSettings) return;

    const newSettings = { ...initialSettings };

    if (existingSettings.ShowAggregations) {
      newSettings.ShowAggregations = true;
    }

    setSettings(newSettings);
  }, [existingSettings]);

  const settingsAreSame = () => {
    if (!existingSettings) return false;

    if (existingSettings.ShowAggregations !== settings.ShowAggregations) {
      return false;
    }

    return true;
  };

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      headerTitle="Table Settings"
      headerOptions={
        <Button
          style={{ width: 60 }}
          size="sm"
          color="primary"
          onClick={handleSave}
          disabled={saving || settingsAreSame()}
        >
          {saving ? <AppSpinner size="sm" color="white" /> : "Save"}
        </Button>
      }
      body={
        <div>
          <CustomToggle
            title="Show Aggregations"
            description={
              <>
                Show aggregations for each field in the table that is a number
                type. <br /> (Number, Percent, Currency, Currency Interval)
              </>
            }
            stateName="ShowAggregations"
            value={settings.ShowAggregations}
            handleChange={handleCheckboxChange}
          />
          {message && (
            <Alert
              className="text-center"
              style={{ position: "absolute", bottom: 80, width: 550 }}
              color={message?.color}
            >
              {message?.text}
            </Alert>
          )}
        </div>
      }
    />
  );
};

export default TableSettings;
